export const CATEGORIES: Array<{
  id: number;
  name: string;
  sub: string;
  isServiceNiche: boolean;
  templateType: 'FOOD' | 'TECHNICAL' | 'STANDARD';
}> = [
  { id: 1, name: 'Alimentação e Gastronomia', sub: 'Confeitaria, Marmitas, Buffets', isServiceNiche: false, templateType: 'FOOD' },
  { id: 2, name: 'Serviço Fixo', sub: 'Estética, Saúde, Beleza', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 3, name: 'Obras e Reparos', sub: 'Manutenção Civil, Reformas', isServiceNiche: true, templateType: 'TECHNICAL' },
  { id: 4, name: 'Instalações e Reparos', sub: 'Elétrica, Hidráulica, Ar Cond.', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 5, name: 'Serviços Automotivos', sub: 'Lava-jato, Mecânica Leve', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 6, name: 'Moda e Costura', sub: 'Ajustes, Confecção local', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 7, name: 'Eventos e Festas', sub: 'DJ, Garçom, Buffet', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 8, name: 'Manutenção Mecânica/Tec.', sub: 'Celular, Bicicleta, Computador', isServiceNiche: true, templateType: 'TECHNICAL' },
  { id: 9, name: 'Serviços Criativos e Tecnologia', sub: 'Design, TI, Social Media', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 10, name: 'Educação e Consultoria', sub: 'Professor, Personal, Consultor', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 11, name: 'Varejo e Revenda', sub: 'Catálogo, Ambulante', isServiceNiche: false, templateType: 'STANDARD' },
  { id: 12, name: 'Serviços Domésticos', sub: 'Faxina, Babá', isServiceNiche: true, templateType: 'STANDARD' },
  { id: 13, name: 'Outros Serviços', sub: 'Diversos', isServiceNiche: true, templateType: 'STANDARD' },
];
